import type {
  EntitiesColumnType,
  EntitiesV2FilterObject,
} from '@/_types/entities';
import type { SelectItem } from '@/_components';

export type KnownEntityType =
  | 'Individual'
  | 'Partnership'
  | 'Trust'
  | 'Custom'
  | 'Exempt Organization'
  | 'S-Corporation'
  | 'C-Corporation';

export const ENTITY_TYPES: Array<KnownEntityType> = [
  'Individual',
  'Partnership',
  'Trust',
  'Exempt Organization',
  'S-Corporation',
  'C-Corporation',
] as const;

export const ENTITY_TABLE_HEADER_MAP: Record<EntitiesColumnType, string> = {
  select: '',
  name: 'Name',
  firm_role: 'Firm Role',
  entity_type: 'Type',
  email: 'Entity Email',
  assigned_advisor_id: 'Assigned Firm User',
  external_entity_id: 'External Entity ID',
  entity_tags: 'Tags',
  actions: '',
};

export const DEFAULT_ENTITY_COLUMNS: Array<EntitiesColumnType> = [
  'select',
  'name',
  'entity_type',
  'email',
  'assigned_advisor_id',
  'entity_tags',
  'actions',
];

export const DEFAULT_V2_ENTITY_FILTER: EntitiesV2FilterObject = {
  assigned_advisor_id: -1,
  count: false,
  descending: true,
  entity_type: '',
  firm_role_id: -1,
  firm_role_user_id: -1,
  page: 0,
  rows_per_page: 10,
  search_term: '',
  selected_entity_tags_filter: [],
  sort_by: 'created_at',
  hide_inactives: false,
  hide_actives: false,
  show_only_deleted: false,
};

export const ENTITY_TYPE_ITEMS: Array<SelectItem> = ENTITY_TYPES.map((et) => ({
  name: et,
  value: et,
}));

export const ALL_ENTITY_TYPE_ITEMS: Array<SelectItem> = [
  { name: 'All Entity Types', value: 'All' },
  ...ENTITY_TYPE_ITEMS,
];
